import * as React from "react";
import OpQuotesHeadingDsk, { IOpQuotesHeadingDskProps } from "../partials/opQuotesHeadingDsk";
import OpMarketDepthList from "../partials/opMarketDepthList";
import "../../../../../assets/scss/components/toc/orderPlacement/opQuotes/opQuotesDsk.scss";
import moment from "moment";
import { toINR } from "../../../../service/numberFormat";

export interface IOpQuotesNfoDskProps {
	quoteData: any;
	quoteDataExtra: any;
}

const OpQuotesNfoDsk: React.FC<IOpQuotesNfoDskProps> = props => {
	const quotesHeadingProps: IOpQuotesHeadingDskProps = {
		dpNm: props.quoteDataExtra.Name,
		dateRange: `${props.quoteDataExtra.OpenDate ? moment(props.quoteDataExtra.OpenDate).format("DD MMM") : "--"} - ${
			props.quoteDataExtra.CloseDate ? moment(props.quoteDataExtra.CloseDate).format("DD MMM") : "--"
		}`
	};

	return (
		<section className="quotes_cont">
			<OpQuotesHeadingDsk {...quotesHeadingProps} />

			<button className="change_btn" onClick={console.log}>
				Change
			</button>

			<div className="mg-t15 mg-b2">
				<OpMarketDepthList
					data={[
						{ label: "Fund Class", value: "Equity" },
						{ label: "Min Investment", value: toINR(props.quoteData.MinPurAmt) },
						{ label: "Entry Load", value: props.quoteDataExtra.EntryLoad || "NA" },
						{ label: "Lock in Period", value: props.quoteDataExtra.LockinPeriod || "NA" },
						{ label: "Risk", value: props.quoteDataExtra.RiskCategory || "NA" }
					]}
				/>
			</div>
		</section>
	);
};

export default OpQuotesNfoDsk;
